export const orderDetailsPageRoutePath = [
  '/orders/:orderId([0-9a-f]{32})/shipments/:batchEntryId(\\d+)',
  '/orders/:orderId([0-9a-f]{32})',
];
